import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { htmlDocsAPI } from '../../services/api';

/**
 * Pinta un documento HTML dentro de un iframe en sandbox.
 *
 * El sandbox va sin `allow-same-origin` a proposito: el documento se ejecuta en
 * un origen opaco, de modo que sus scripts pueden funcionar (una presentacion o
 * un checklist los necesitan) pero no alcanzan ni la sesion ni el DOM de la
 * aplicacion. Por eso el contenido llega como texto y se inyecta con `srcDoc`,
 * y no apuntando el iframe a la URL: la peticion necesita el token.
 */
export default function HtmlDocViewer({ docId, title, sx }) {
  const [html, setHtml] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setHtml(null);
    setError('');
    if (!docId) return undefined;

    htmlDocsAPI.content(docId)
      .then((res) => {
        if (!cancelled) setHtml(typeof res.data === 'string' ? res.data : String(res.data));
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e.response?.data?.detail || 'No se ha podido abrir el documento.');
        }
      });

    return () => { cancelled = true; };
  }, [docId]);

  if (error) return <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>;
  if (html === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: '100%', ...sx }}>
      <iframe
        title={title || 'Documento HTML'}
        srcDoc={html}
        sandbox="allow-scripts allow-popups allow-forms allow-modals"
        style={{ width: '100%', height: '100%', border: 0, backgroundColor: '#fff' }}
      />
    </Box>
  );
}
